import {IconProps} from './types';

const ArrowLine = ({fill = 'currentColor', className}: IconProps) => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        className={className}
      >
        <g clipPath="url(#clip0_18462_28691)">
          <path
            fill={fill}
            d="M.862 7.529a.667.667 0 0 0 0 .942l3.771 3.772a.67.67 0 0 0 .951.008.667.667 0 0 0-.008-.95L2.942 8.666H15a.667.667 0 1 0 0-1.334H2.942L5.576 4.7a.667.667 0 0 0-.943-.943z"
          ></path>
        </g>
        <defs>
          <clipPath id="clip0_18462_28691">
            <path fill={fill} d="M0 16V0h16v16z"></path>
          </clipPath>
        </defs>
      </svg>
    );
    
    export default ArrowLine;
    